/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 受令場所
 */
export type IncidentDispatchStatusEnum =
  (typeof IncidentDispatchStatusEnum)[keyof typeof IncidentDispatchStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentDispatchStatusEnum = {
  STANDBY: 'STANDBY',
  EMERGENCY_SITE: 'EMERGENCY_SITE',
  IN_TRANSIT: 'IN_TRANSIT',
  AFTER_HOSPITAL_ADMISSION: 'AFTER_HOSPITAL_ADMISSION',
  RETURNING: 'RETURNING',
  ON_MISSION: 'ON_MISSION',
  OTHER: 'OTHER',
} as const;
